var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 59 55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#246CFF",
    d: "M40.86 54.078 34.084 42.24a8.505 8.505 0 0 0-7.385-4.28l-18.424.01a8.056 8.056 0 0 0-8.051 8.055 8.052 8.052 0 0 0 8.051 8.052H40.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF395A",
    d: "m6.282 33.432 13.545.01a8.505 8.505 0 0 0 7.387-4.278l9.257-16.161a8.062 8.062 0 0 0-2.944-10.977 7.964 7.964 0 0 0-10.911 2.923L6.282 33.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7D7",
    d: "M41.278 13.706 34.496 25.43a8.505 8.505 0 0 0 .012 8.536l9.367 16.097a8.062 8.062 0 0 0 10.979 2.939 7.964 7.964 0 0 0 2.924-10.911l-16.5-28.386Z"
  }))));
};
export default SvgLogo;